import { graphConfig } from "./azureADNew"; /** * Attaches a given access token to a Microsoft Graph API call. Returns information about the user */

export async function getUserDetails(accessToken) {

    const headers = new Headers();
    const bearer = `Bearer ${accessToken}`;
    headers.append("Authorization", bearer);
    const options = { method: "GET", headers: headers };
    return fetch(graphConfig.graphMeEndpoint, options).then(response => response.json()).catch(error => console.error(error));

}
